// Dependencies
// ------------

import { breakpoints } from './breakpoints';

// Internal
// --------

const getBreakpoint = (type, name) => (
  !breakpoints[type] ? undefined : breakpoints[type][name].replace(/'/g, '')
);

// Exports
// -------

// Media queries

export {
  getBreakpoint
};

export default (() => {
  const mediaQueries = {};

  Object.keys(breakpoints).forEach((type) => {
    Object.keys(breakpoints[type]).forEach((breakpoint) => {
      mediaQueries[`${ type }-${ breakpoint }`] = {
        query: `(min-${ type }:${ getBreakpoint(type, breakpoint) })`
      };
    });
  });

  return mediaQueries;
})();
